import {convertToUrlParams} from 'utils'
import baseApi, {provideTag} from './baseApi'

const structuresApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getStructures: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `structures${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('Structure'),
        }),
        getStructure: build.query({
            query: (id) => {
                return {
                    url: `structures/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('Structure', result),
        }),
        deleteStructure: build.mutation({
            query: (id) => {
                return {
                    url: `structures/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Structure'],
        }),
        createStructure: build.mutation({
            query: (data) => {
                return {
                    url: `structures`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Structure'],
        }),
        editStructure: build.mutation({
            query: (data) => {
                return {
                    url: `structures/${data._id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Structure'],
        }),
    }),
    overrideExisting: false,
})

export default structuresApi

export const {
    useGetStructuresQuery,
    useGetStructureQuery,
    useDeleteStructureMutation,
    useCreateStructureMutation,
    useEditStructureMutation,
} = structuresApi
